function get<T>(key: string): null | T  {
  const data: string | null = window.sessionStorage.getItem(key)
  return data ? JSON.parse(data) as T : null
}

function remove(key: string): void {
  window.sessionStorage.removeItem(key)
}

function set(key: string, data: Record<string, unknown>): void {
  window.sessionStorage.setItem(key, JSON.stringify(data))
}

export default {
  get,
  remove,
  set,
}
